
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article-landing",
      function () {
        return require("private-next-pages/article-landing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article-landing"])
      });
    }
  